class NotImplementedError extends Error {
    constructor(message = "Not implemented") {
        super(message);
    }
}
class InvalidOperationError extends Error {
    constructor(message = "Invalid operation") {
        super(message);
    }
}
class ArgumentError extends Error {
    constructor(message = "Argument error") {
        super(message);
    }
}
export { ArgumentError, InvalidOperationError, NotImplementedError };
